import React, { useState, useEffect,useRef } from 'react';
import { 
    getDatabase, 
    ref, 
    push, 
    onValue, 
    serverTimestamp, 
    set,
    get,
    off,
    update, remove
} from 'firebase/database';
// import defaultProfileImg from './images/plotlogo.svg';
import bird from "./images/BIRD.svg";
import panda from "./images/PANDA.svg";
import rabbit from "./images/RABBIT.svg";
import pig from "./images/PIG.svg";
import fox from "./images/FOX.svg";
import bear from "./images/BEAR.svg";
import crow from "./images/CROW.svg";
import cow from "./images/COW.svg";
import snail from "./images/SNAIL.svg";
import penguin from "./images/PENGUIN.svg";
import frog from "./images/FROG.svg";
import raccoon from "./images/RACCOON.svg";
import zebra from "./images/ZEBRA.svg";
import elephant from "./images/ELEPHANT.svg";
import axolotl from "./images/AXOLOTL.svg";
import { BiCaretDown, BiCaretLeft, BiTrash, BiXCircle, BiCog, BiHide } from "react-icons/bi";
import { AiFillStop } from "react-icons/ai";
import { FaUserSlash } from "react-icons/fa";
import { BiMessageAltDetail } from "react-icons/bi";

function Messenger({ isMessageEditMode, setIsMessageEditMode, setHasUnreadMessages, selectedConversation, setSelectedConversation, currentUserId, setSelectedUserProfile, selectedUserProfile, post, setMobileConversationView, mobileConversationView, isLoading, setIsLoading}) {
    const [messages, setMessages] = useState([]);
    const [conversations, setConversations] = useState([]);
    const [error, setError] = useState('');
    const [newMessage, setNewMessage] = useState('');
    const [usernames, setUsernames] = useState({});
    const [conversationEditMode, setConversationEditMode] = useState(false);
    const [showBlockConfirm, setShowBlockConfirm] = useState(false);
    const [userToBlock, setUserToBlock] = useState({id: null, username: ''});

    


    const messagesListRef = useRef(null);
    const lastMessageRef = React.useRef(null);
    const db = getDatabase();

    const profileImages = [
        bird, panda, rabbit, pig, fox, bear, crow, cow, snail, penguin,
        frog, raccoon, zebra, elephant, axolotl
      ];

      function getUserIdHash(userId) {
        let hash = 0;
        for (let i = 0; i < userId.length; i++) {
            const char = userId.charCodeAt(i);
            hash = ((hash << 5) - hash) + char; // Left shift and add char
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }
    
    function getDefaultProfileImgForUser(userId) {
        const index = Math.abs(getUserIdHash(userId)) % profileImages.length;
        return profileImages[index];
    }
      
    const handleHideConversation = async (convoId) => {
        const convoRef = ref(db, `conversations/${convoId}`);
        const convoSnapshot = await get(convoRef);
        const convoData = convoSnapshot.val();
    
        let hiddenFor = convoData.hiddenFor || [];
        if (!hiddenFor.includes(currentUserId)) {
            hiddenFor.push(currentUserId);
        }
    
        await update(convoRef, { hiddenFor });
    };

    const fetchUserProfile = async (uid) => {
        const userProfileRef = ref(db, `users/${uid}`);
        const snapshot = await get(userProfileRef);
        return snapshot.val();
    };

    const createEmptyConversation = async (participant1, participant2) => {
        const conversationsRef = ref(db, 'conversations');
        const newConvoRef = push(conversationsRef);
        await set(newConvoRef, {
            participant1: participant1,
            participant2: participant2,
            latestMessage: serverTimestamp()
        });
        return newConvoRef.key; // Return the ID of the new conversation
    };


    const isToday = (date) => {
        const today = new Date();
        return date.getDate() === today.getDate() &&
               date.getMonth() === today.getMonth() &&
               date.getFullYear() === today.getFullYear();
    }
    
    const formatDateWithTime = (timestamp) => {
        if (!timestamp || isNaN(new Date(timestamp))) {
            return "Invalid date";
        }
    
        const date = new Date(timestamp);
        
        if (isToday(date)) {
            // Display only the time if the date is today
            return new Intl.DateTimeFormat('en-US', {
                hour: '2-digit', 
                minute: '2-digit'
            }).format(date);
        } else {
            // Display the full date if it's not from today
            return new Intl.DateTimeFormat('en-US', {
                month: 'short', 
                day: '2-digit'
            }).format(date);
        }
    };
    

useEffect(() => {
    if (messagesListRef.current) {
        setTimeout(() => {
            messagesListRef.current.scrollTop = messagesListRef.current.scrollHeight;
        }, 100); // A slight delay to ensure messages are rendered
    }
}, [messages]);

    
    const handleSendMessage = async (event) => {
        event.preventDefault();

          // Fetch the logged-in user's data
    const currentUserRef = ref(db, `users/${currentUserId}`);
    const userSnapshot = await get(currentUserRef);
    const userData = userSnapshot.val();
    
    // Check if the user has set a username
    if (!userData.username) {
        setError("You must set a username to send messages");
        setTimeout(() => {
            setError(null);  // Clear the error message after 3 seconds
        }, 3000); 
        return;
    }
        
        if (newMessage.trim() === "" || !selectedUserProfile) return;
        const recipientId = selectedUserProfile.uid;

        // Check if a conversation exists between the two users
        const conversationsRef = ref(db, 'conversations');
        let conversationId = null;
        
        const conversationsSnapshot = await get(conversationsRef);
        const conversationsData = conversationsSnapshot.val();
        
        for (let id in conversationsData) {
            const convo = conversationsData[id];
            if ((convo.participant1 === currentUserId && convo.participant2 === recipientId) || 
                (convo.participant1 === recipientId && convo.participant2 === currentUserId)) {
                conversationId = id;
                break;
            }
        }
    
        // Check if you're blocked by the recipient or if you blocked the recipient
        const recipientBlockedUsersRef = ref(db, `users/${recipientId}/blockedUsers/${currentUserId}`);
        const currentUserBlockedUsersRef = ref(db, `users/${currentUserId}/blockedUsers/${recipientId}`);
        const [recipientBlockedSnapshot, currentUserBlockedSnapshot] = await Promise.all([
            get(recipientBlockedUsersRef),
            get(currentUserBlockedUsersRef)
        ]);
    
        if (recipientBlockedSnapshot.exists() || currentUserBlockedSnapshot.exists()) {
            setError("This conversation is blocked.");
            setTimeout(() => {
                setError(null);  // Clear the error message after 3 seconds
            }, 3000); 
            return;
        }

        
    
        // If no conversation exists, create one
       if (!conversationId) {
    if (selectedConversation && selectedConversation.isGhost) {
        // Create an empty conversation and get its ID
        conversationId = await createEmptyConversation(currentUserId, selectedUserProfile.uid);

        const newConvo = {
            id: conversationId,
            participant1: currentUserId,
            participant2: selectedUserProfile.uid,
            latestMessage: Date.now()

        };

        // setConversations(prevConversations => [...prevConversations.filter(convo => convo.id !== selectedConversation.id), newConvo]); // replace the ghost conversation with the real one
        console.log("setConversations1");
        setSelectedConversation(newConvo);  // Update with the real conversation details
    } else {
        const newConvoRef = push(conversationsRef);
        conversationId = newConvoRef.key;

        const newConvo = {
            id: conversationId,
            participant1: currentUserId,
            participant2: selectedUserProfile.uid,
            latestMessage: Date.now()

        };

        await set(newConvoRef, newConvo);

     
        setSelectedConversation(newConvo);
    }
}
        // Now send the message under this conversationId
        const messageRef = ref(db, `messages/${conversationId}`);
        const newMessageRef = push(messageRef);
    
        const messageData = {
            senderId: currentUserId,
            content: newMessage,
            timestamp: serverTimestamp(),
            read: false
        };
        
        // Update latest message timestamp and unhide the conversation for both users
        const conversationToUpdateRef = ref(db, `conversations/${conversationId}`);
        update(conversationToUpdateRef, {
            latestMessage: serverTimestamp(),
            hiddenFor: []  // Clear the hiddenFor field to unhide for both users
        });
        
        if (messagesListRef.current) {
            const scrollHeight = messagesListRef.current.scrollHeight;
            messagesListRef.current.scrollTop = scrollHeight;
        }
        
        set(newMessageRef, messageData);
        setNewMessage('');
    };


    const fetchLatestMessage = async (convoId) => {
        const messagesRef = ref(db, `messages/${convoId}`);
        let messageSnapshot = await get(messagesRef);
        let messagesData = messageSnapshot.val();
        let latestMessage = null;
    
        for (let key in messagesData) {
            if (!latestMessage || messagesData[key].timestamp > latestMessage.timestamp) {
                latestMessage = messagesData[key];
            }
        }
    
        return latestMessage;
    };
    

    useEffect(() => {
        const usernamesRef = ref(db, 'usernames');
        
        // Fetch usernames from the database
        const unsubscribe = onValue(usernamesRef, snapshot => {
            const data = snapshot.val();
            setUsernames(data || {});
        }, error => {
            // Handle any errors that occur during the fetch
            console.error("Error fetching usernames:", error);
        });
        
        return () => {
            off(usernamesRef, 'value', unsubscribe); // Clean up the listener when the component unmounts
        };
    }, [db]);
    const getUsernameById = (id) => {
        // Finding the username for the given user ID
        for (let username in usernames) {
            if (usernames[username] === id) {
                return username;
            }
        }
        return null; // Return null if not found
    }


    
   useEffect(() => {
    setIsLoading(true);
    const conversationsRef = ref(db, 'conversations');

    const fetchUnreadCount = async (convoId) => {
        const messagesSnapshot = await get(ref(db, `messages/${convoId}`));
        const messagesData = messagesSnapshot.val();
        let unreadCount = 0;

        for (let key in messagesData) {
            const msg = messagesData[key];
            if (!msg.read && msg.senderId !== currentUserId) {
                unreadCount++;
            }
        }

        return unreadCount;
    };

    // Fetch the user's conversations
    const fetchBlockedUsers = async () => {
        const blockedUsersRef = ref(db, `users/${currentUserId}/blockedUsers`);
        const snapshot = await get(blockedUsersRef);

        const blockedUserIds = [];
        if (snapshot.exists()) {
            for (let userId in snapshot.val()) {
                blockedUserIds.push(userId);
            }
        }
        return blockedUserIds;
    };

    fetchBlockedUsers().then(blockedUserIds => {
        // Fetch the user's conversations
        const unsubscribe = onValue(conversationsRef, async snapshot => {
            const data = snapshot.val();
            const userConversations = []; // Start with an empty array

            if (data) {
                for (let key in data) {
                    const convo = data[key];
                    if (((convo.participant1 === currentUserId && !blockedUserIds.includes(convo.participant2))
    || (convo.participant2 === currentUserId && !blockedUserIds.includes(convo.participant1)))
    && (!convo.hiddenFor || !convo.hiddenFor.includes(currentUserId))) {
                        const unreadCount = await fetchUnreadCount(key);
                        const latestMessageData = await fetchLatestMessage(key);
                        const otherParticipantId = convo.participant1 === currentUserId ? convo.participant2 : convo.participant1;
                        const otherUserProfile = await fetchUserProfile(otherParticipantId);
                        userConversations.push({
                            id: key,
                            unreadCount: unreadCount,
                            latestMessageData: latestMessageData,
                            otherUserProfile: otherUserProfile,
                            ...convo
                        });
                    }
                }
            } else {
                console.log("No conversations found for this user.");
            }

            // Filter duplicates using a Map to ensure unique conversation IDs
            const uniqueConversations = [...new Map(userConversations.map(convo => [convo.id, convo])).values()];
            setConversations(uniqueConversations.sort((a, b) => b.latestMessage - a.latestMessage));
            setIsLoading(false);

        }, error => {
            console.error("Error fetching user's conversations:", error);
        });

        return () => {
            off(conversationsRef, 'value', unsubscribe);
        };
    });
}, [currentUserId, db]);

    
const handleDeleteMessage = async (messageId) => {
    const messageRef = ref(db, `messages/${selectedConversation.id}/${messageId}`);
    await remove(messageRef);
};

useEffect(() => {
    if (selectedConversation) {
        const messagesRef = ref(db, `messages/${selectedConversation.id}`);
        setError('');

        // Just fetch messages and set them, don't mark as read here
        const unsubscribe = onValue(messagesRef, snapshot => {
            const data = snapshot.val();
            const loadedMessages = [];
            const updatePromises = []; 

            if (data) {
                for (let key in data) {
                    const msg = data[key];
                    loadedMessages.push({
                        id: key,
                        ...msg
                    });

                    if (!msg.read && msg.senderId !== currentUserId) {
                        // If the message is for the currently selected conversation, mark it as read
                        if (selectedConversation.id === msg.conversationId) {
                            const unreadMsgRef = ref(db, `messages/${selectedConversation.id}/${key}`);
                            const updatePromise = update(unreadMsgRef, { read: true });
                            updatePromises.push(updatePromise);
                        }
                    }
                }
            }

            Promise.all(updatePromises).then(() => {
                setMessages(loadedMessages);
            });
            
            if (messagesListRef.current) {
                const scrollHeight = messagesListRef.current.scrollHeight;
                messagesListRef.current.scrollTop = scrollHeight;
            }
        });

        // Separate logic to mark messages as read
        markMessagesAsRead(selectedConversation.id); 
         // Assuming you've abstracted the marking logic into a function

        return () => {
            off(messagesRef, 'value', unsubscribe);
        };
    } else {
        setMessages([]);
    }
}, [selectedConversation, db]);

const markMessagesAsRead = async (convoId) => {
    console.log("Marking messages as read for conversation:", convoId); // Logging

    const messagesSnapshot = await get(ref(db, `messages/${convoId}`));
    const messagesData = messagesSnapshot.val();
    const updatePromises = [];

    if (messagesData) {
        for (let key in messagesData) {
            const msg = messagesData[key];

            if (!msg.read && msg.senderId !== currentUserId) {
                console.log("Found unread message, marking as read:", key); // Logging

                const unreadMsgRef = ref(db, `messages/${convoId}/${key}`);
                const updatePromise = update(unreadMsgRef, { read: true });
                updatePromises.push(updatePromise);
            }
        }

        await Promise.all(updatePromises);
    } else {
        console.log("No messages found for this conversation."); // Logging
    }
    setConversations(prevConversations => {
        return prevConversations.map(convo => {
            if (convo.id === convoId) {
                return {
                    ...convo,
                    unreadCount: 0 // Set unreadCount to 0 for the read conversation
                };
            }
            return convo;
        });
    });
}


useEffect(() => {
    if (messagesListRef.current) {
        messagesListRef.current.scrollTop = messagesListRef.current.scrollHeight;
    }
}, [messages]);
    

useEffect(() => {
    function checkAndScroll() {
        if (messagesListRef.current) {
            messagesListRef.current.scrollTop = messagesListRef.current.scrollHeight;
        } else {
            // If the messagesListRef is not available yet, keep checking until it is
            requestAnimationFrame(checkAndScroll);
        }
    }
    
    checkAndScroll();
}, [selectedConversation]);

const handleBlockConversation = async ({id: conversationIdToBlock}) => {
    const conversationRef = ref(db, `conversations/${conversationIdToBlock}`);
    const snapshot = await get(conversationRef);
    const conversationData = snapshot.val();

    let userIdToBlock;
    if (conversationData.participant1 === currentUserId) {
        userIdToBlock = conversationData.participant2;
    } else {
        userIdToBlock = conversationData.participant1;
    }

    // Add the user to the current user's blockedUsers list
    const userBlockedUsersRef = ref(db, `users/${currentUserId}/blockedUsers/${userIdToBlock}`);
    await set(userBlockedUsersRef, true);

    // Optionally, remove the conversation from the state/UI
    setConversations(prevConversations => prevConversations.filter(convo => convo.id !== conversationIdToBlock));
};




 
    return (
        <div className="messenger_component_container">
        <div className="messenger_container">

        {showBlockConfirm && 
        <div className="overlay">
        <div className="messages_block_user_confirmation_container">
        <div className="border_accent_div_red"></div>
        <div className="profile_block_user_icon"><FaUserSlash /></div>
    <div className="profile_block_user_confirmation">
    {`Are you sure you want to block ${userToBlock.username}? You can manage blocked users in your profile.`}
    </div>

    <div className="profile_block_user_confirmation_button_container">
        <button 
            className="profile_block_user_confirmation_block_button" 
            onClick={() => {
                handleBlockConversation(userToBlock);
                setShowBlockConfirm(false);  // Close the confirmation modal after blocking
            }}
        >
            Block User
        </button>
        <button 
            className="profile_block_user_confirmation_cancel_button" 
            onClick={() => {
                setShowBlockConfirm(false);
            }} 
        >
            Cancel
        </button>
    </div></div>
</div>}


{mobileConversationView && !isLoading && 
    <div className="conversations_list_mobile">
        <div className="conversations_list_button_container">
            {/* <button onClick={() => setMobileConversationView(!mobileConversationView)} className="mobile_conversations_toggle">
                <BiCaretUp />Conversations
            </button> */}
            {conversations.length > 0 && <button className={!conversationEditMode ? 'conversation_edit_mode_toggle' : 'conversation_edit_mode_toggle_active'} onClick={() => setConversationEditMode(!conversationEditMode)}>
                <BiCog />
            </button>}
        </div>
        <div className="conversations_inset">
            {conversations.length === 0 ? (
                // Empty state
               <div className="empty_conversations_state">
                    <p className="no_convos_empty_state">No conversations found!</p>
                </div>
            ) : (
                // List of conversations
                conversations.map(convo => {
                    const otherParticipantId = convo.participant1 === currentUserId ? convo.participant2 : convo.participant1;
                    const otherParticipantUsername = getUsernameById(otherParticipantId) || "Unknown User";
                    const defaultProfileImg = getDefaultProfileImgForUser(otherParticipantId);
                    const otherParticipantProfilePic = convo.otherUserProfile?.profilePicURL || defaultProfileImg;
                    
                    return (
                        <div 
                            className={`conversation_container_mobile ${selectedConversation && convo.id === selectedConversation.id ? 'active_conversation' : ''}`} 
                            key={convo.id} 
                            onClick={async () => {
                                console.log("Setting selected conversation:", convo);
                                setSelectedConversation(convo);
                            
                                // Fetch the profile of the other participant and set it
                                const otherUserProfile = await fetchUserProfile(otherParticipantId);
                                setSelectedUserProfile(otherUserProfile);
                                setMobileConversationView(false);
                            }}
                        >
                            {!isLoading && 
                            
                            <div className="conversation_list_container_mobile">
                                <div className="conversation_list_unread_badge_container">
                                {conversationEditMode && 
                                <button 
                                        className="messenger_block_user_button" 
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setUserToBlock({id: convo.id, username: otherParticipantUsername});  // Set the conversation/user ID to block
        setShowBlockConfirm(true);
                                        }}
                                >
                                       <AiFillStop />
                                </button>
                                
                                
                                
                                }    
                                {convo.unreadCount > 0 && !conversationEditMode && <div className="conversation_list_unread_badge">
                                        {convo.unreadCount > 0 && ` ${convo.unreadCount}`}  
                                        </div>}
                                
                                    
                                </div>

                                <img src={otherParticipantProfilePic} alt="Other Participant Profile Pic" className={convo.otherUserProfile?.profilePicURL ? "conversation_list_pro_pic_container" : "conversation_list_pro_pic_container_default"}/>
                                   
                                <div className="conversation_list_username_container">
                                    <div className="conversation_list_username_and_last_message_container">
                                    {otherParticipantUsername}    <div className="latest-message">
                    {convo.latestMessageData?.content}
                </div></div>
                                </div>


                                <div className="conversation_list_timestamp_container">
                                       <div> {formatDateWithTime(convo.latestMessage)}</div><div className="block_button_container_conversations">
                                       </div>
                                </div>
                                    
                               <div className="conversation_list_block_container">

                               {conversationEditMode && <button 
    className="conversations_hide_conversation_button" 
    onClick={(e) => {
        e.stopPropagation();
        handleHideConversation(convo.id);
        setSelectedConversation(null);
    }}
>
    <BiHide />
</button>}        


                               </div>
                                
                               
                            </div>}
                        </div>
                    );
                })
            )}
        </div>
        <div className="messages_icon_container"><BiMessageAltDetail /></div>
    </div>
}

{!selectedUserProfile && !mobileConversationView && <button onClick={() => setMobileConversationView(true)} className="mobile_conversations_toggle">
    <BiCaretLeft />Conversations
  </button>}

<div className="conversations_list">
{conversations.length > 0 && <button className={!conversationEditMode ? 'conversation_edit_mode_toggle' : 'conversation_edit_mode_toggle_active'} onClick={() => setConversationEditMode(!conversationEditMode)}><BiCog /></button>}
{conversations.length === 0 && <p className="no_convos_empty_state">No conversations found!</p>}
{conversations.map(convo => {
        // Determine the other participant's ID
        const otherParticipantId = convo.participant1 === currentUserId ? convo.participant2 : convo.participant1;
        const otherParticipantUsername = getUsernameById(otherParticipantId) || "Unknown User";

        return (
            <div 
                className={`conversation_container ${selectedConversation && convo.id === selectedConversation.id ? 'active_conversation' : ''}`} 
                key={convo.id} 
                onClick={async () => {
                    console.log("Setting selected conversation:", convo);
                    setSelectedConversation(convo);
                    setConversationEditMode(false);
                    // Get the other participant's ID
                    const otherParticipantId = convo.participant1 === currentUserId ? convo.participant2 : convo.participant1;
                    
                    // Fetch the profile of the other participant and set it
                    const otherUserProfile = await fetchUserProfile(otherParticipantId);
                    setSelectedUserProfile(otherUserProfile);
                    
                }}
            >
                 {!isLoading && <div className="conversation_list_container_column">
                 
<div className="conversation_list_username_container">
{conversationEditMode && 
                                <button 
                                        className="messenger_block_user_button" 
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setUserToBlock({id: convo.id, username: otherParticipantUsername});  // Set the conversation/user ID to block
        setShowBlockConfirm(true);
                                        }}
                                >
                                       <AiFillStop />
                                </button>
                                
                                
                                
                                } 
{otherParticipantUsername} </div>

                 <div className="conversation_list_timestamp_container">
                 {convo.unreadCount > 0 &&<div className="conversation_list_unread_badge">
                                        {convo.unreadCount > 0 && ` ${convo.unreadCount}`}  
                                        </div>}{formatDateWithTime(convo.latestMessage)} 
                                {conversationEditMode && <button 
    className="conversations_hide_conversation_button" 
    onClick={(e) => {
        e.stopPropagation();
        handleHideConversation(convo.id);
        setSelectedConversation(null);
    }}
>
    <BiHide />
</button>}
                 </div>
                 
                 </div>}
                 
            </div>
        );
    })}
</div>


{selectedUserProfile && (
            <div className="messages_list_container">
                <div className="messages_conversation_edit">
                    <button onClick={() => {          
        setSelectedUserProfile(null);
        setIsMessageEditMode(false);
        setMobileConversationView(true);}} className="mobile_conversations_toggle">
                        <BiCaretLeft />Conversations
                    </button>
                    <button className={!isMessageEditMode ? 'messages_edit_mode_toggle' : 'messages_edit_mode_toggle_active'} onClick={() => setIsMessageEditMode(!isMessageEditMode)}>
                        <BiTrash />
                    </button>
                </div>

                {/* Declare and compute the value of defaultProfileImg */}
                {(() => {
                    console.log(selectedUserProfile.uid)
                    const otherParticipantId = selectedUserProfile?.uid;
                    const defaultProfileImg = getDefaultProfileImgForUser(otherParticipantId);
                    
                    return (
                        <div className="selected_user_info">
                            {selectedUserProfile ? (
                                <>
                                    <img src={selectedUserProfile.profilePicURL ? selectedUserProfile.profilePicURL : defaultProfileImg} alt="User Profile Pic" className={selectedUserProfile.profilePicURL ? "messages_user_profile_pic" : "messages_user_profile_pic_default"} />
                                    <div className="messages_user_profile_container">
                                        <div className="messages_user_profile_username">{selectedUserProfile.username}</div>
                                        <div className="messages_user_profile_aboutme">{selectedUserProfile.description}</div>
                                    </div>
                                </>
                            ) : (
                                <p></p>
                            )}
                        </div>
                    );
                })()}

                <div className="messages_list" ref={messagesListRef}>
                    <div className="spacer"></div>

                    {messages.map((msg, index) => {
                        const date = new Date(msg.timestamp);
                        const formattedDate = new Intl.DateTimeFormat('en-US', {
                            year: 'numeric', 
                            month: 'short', 
                            day: '2-digit', 
                            hour: '2-digit', 
                            minute: '2-digit', 
                            second: '2-digit' 
                        }).format(date);
                        const isLastMessage = index === messages.length - 1;

                        return (
                            <div key={msg.id} ref={isLastMessage ? lastMessageRef : null} className={msg.senderId === currentUserId ? 'sent' : 'received'}>
                                {isMessageEditMode && msg.senderId === currentUserId && (
                                    <button className="messages_delete_message_button" onClick={() => handleDeleteMessage(msg.id)}><BiXCircle /></button>
                                )}
                                <p className="messenger_message_content">{msg.content}</p>
                                <p className={msg.senderId === currentUserId ? 'messenger_timestamp_sent' : 'messenger_timestamp_received'}>{formattedDate}</p>
                            </div>
                        );
                    })}

                    {error && <div className="create_post_error_message_container"><div className="create_post_error_message">{error ? error : ""}</div></div>}
                </div>
                
                <div className="message_form_desktop">
                    <form onSubmit={handleSendMessage} className="message_form">
                        <textarea
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    handleSendMessage(e);
                                }
                            }}
                            type="text"
                            value={newMessage}
                            onChange={(e) => setNewMessage(e.target.value)}
                            placeholder="Type a message..."
                        />
                        <button type="submit">Send</button>
                    </form>
                </div>
            </div>
        )}

        {selectedConversation === null && !mobileConversationView && <div className="messenger_no_conversation_selected">No conversation selected</div>}

        </div></div>
    );
}

export default Messenger;
